/**
 * Teacher-feedback per-session speaking stats (mentor Zoom session).
 *
 * Path: teacherFeedback/data/courses/{courseId}/mentors/{zoomUserId}/sessions/{sessionKey}
 */
import {z} from 'zod';

import {FirestoreTimestampSchema} from '../../types';

import {SharedZoomSpeakingStatsFieldsSchema} from './zoomSpeakingStatsShared';

export const TeacherFeedbackSessionStatsDocumentSchema = z
  .object({
    courseId: z.string(),
    zoomUserId: z.string(),
    sessionKey: z.string(),
    meetingUuid: z.string(),
    sessionStartedAt: FirestoreTimestampSchema,
    /** UTC calendar date YYYY-MM-DD for listing/filtering. */
    sessionDate: z.string(),
  })
  .extend(SharedZoomSpeakingStatsFieldsSchema.shape)
  .loose();

export type TeacherFeedbackSessionStatsDocument = z.infer<
  typeof TeacherFeedbackSessionStatsDocumentSchema
>;

/** All session stats docs for a mentor in a course. */
export function getTeacherFeedbackMentorSessionsCollectionPath({
  courseId,
  zoomUserId,
}: {
  courseId: string;
  zoomUserId: string;
}): string {
  return `teacherFeedback/data/courses/${courseId}/mentors/${zoomUserId}/sessions`;
}

export function getTeacherFeedbackSessionStatsDocumentPath({
  courseId,
  zoomUserId,
  sessionKey,
}: {
  courseId: string;
  zoomUserId: string;
  sessionKey: string;
}): string {
  return `${getTeacherFeedbackMentorSessionsCollectionPath({courseId, zoomUserId})}/${sessionKey}`;
}
